import OneRoom from '@/shared/assets/lk/one_room.png';
import TwoRooms from '@/shared/assets/lk/two_rooms.png';
import FourRooms from '@/shared/assets/lk/four_rooms.png';
import ThreeRooms from '@/shared/assets/lk/three_rooms.png';
import OneRoomScheme from '@/shared/assets/lk/one_room_scheme.png';
import TwoRoomsScheme from '@/shared/assets/lk/two_rooms_scheme.png';
import FourRoomsScheme from '@/shared/assets/lk/four_rooms_scheme.png';
import ThreeRoomsScheme from '@/shared/assets/lk/three_rooms_scheme.png';
import OneRoomSchemeSVG from '@/shared/assets/lk/one_room_scheme.svg?react';
import TwoRoomsSchemeSVG from '@/shared/assets/lk/two_rooms_scheme.svg?react';
import ThreeRoomsSchemeSVG from '@/shared/assets/lk/four_rooms_scheme.svg?react';
import FourRoomsSchemeSVG from '@/shared/assets/lk/three_rooms_scheme.svg?react';
import { Goal } from './types';

export const GOALS: Goal[] = [
    {
        id: 1,
        image: OneRoom,
        minMeters: 20,
        roomsCount: 1,
        squareMeters: 32,
        schemeImage: OneRoomScheme,
        schemeImageSVG: OneRoomSchemeSVG,
        title: '1-х комнатная квартира 32\u00A0м²',
    },
    {
        id: 2,
        image: TwoRooms,
        minMeters: 30,
        roomsCount: 2,
        squareMeters: 56,
        schemeImage: TwoRoomsScheme,
        schemeImageSVG: TwoRoomsSchemeSVG,
        title: '2-х комнатная квартира 56\u00A0м²',
    },
    {
        id: 3,
        image: ThreeRooms,
        minMeters: 40,
        roomsCount: 3,
        squareMeters: 84,
        schemeImage: ThreeRoomsScheme,
        schemeImageSVG: ThreeRoomsSchemeSVG,
        title: '3-х комнатная квартира 84\u00A0м²',
    },
    {
        id: 4,
        image: FourRooms,
        minMeters: 50,
        roomsCount: 4,
        squareMeters: 112,
        schemeImage: FourRoomsScheme,
        schemeImageSVG: FourRoomsSchemeSVG,
        title: '4-х комнатная квартира 112\u00A0м²',
    },
].reverse();

export const GOALS_MAP = new Map<number, Goal>();

GOALS.forEach((el) => {
    GOALS_MAP.set(el.id, el);
});
